module.exports = __webpack_public_path__ + "static/media/leona-prudilova-cv.9cd2b218.pdf";